import { Trophy } from "lucide-react";

export const Leaderboard = ({ data, meId }) => (
  <div className="card space-y-3" data-testid="leaderboard">
    <div className="flex items-center gap-2">
      <Trophy size={22} className="text-[#ca8a04]" />
      <h2 className="font-heading text-2xl font-bold uppercase">This week's leaders</h2>
    </div>
    {!data?.rows.length && <p className="text-sm font-semibold text-[var(--muted)]" data-testid="leaderboard-empty">No practice yet this week. Be the first!</p>}
    <ol className="space-y-1.5">
      {data?.rows.map((r, i) => (
        <li key={r.player_id} data-testid={`leaderboard-row-${i}`} className={`leader-row ${r.player_id === meId ? "leader-me" : ""}`}>
          <span className={`leader-rank ${i < 3 ? `rank-${i}` : ""}`}>{i + 1}</span>
          <span className="flex-1 truncate font-bold">{r.name}</span>
          <span className="font-mono text-sm font-bold">{r.correct} right</span>
          <span className="font-mono text-xs text-[var(--muted)] w-12 text-right">{Math.round(r.accuracy * 100)}%</span>
        </li>
      ))}
    </ol>
  </div>
);
